import type { JSX } from 'react';
import { Link, Outlet, createFileRoute } from '@tanstack/react-router';
import { useIntl } from 'react-intl';

export const Route = createFileRoute('/_app/developers')({
  component: DevelopersLayout,
});

function DevelopersLayout(): JSX.Element {
  const intl = useIntl();

  return (
    <section className="space-y-6">
      <header>
        <h1 className="text-xl font-semibold tracking-tight text-navy-900">
          {intl.formatMessage({ id: 'developers.title', defaultMessage: 'Developers' })}
        </h1>
        <p className="mt-1 text-sm text-navy-600">
          {intl.formatMessage({
            id: 'developers.subtitle',
            defaultMessage:
              'Manage API keys and webhook endpoints for integrating with the Caratuva API.',
          })}
        </p>
      </header>

      <nav className="flex gap-1 border-b border-navy-200">
        <Link
          to="/developers/api-keys"
          className="-mb-px border-b-2 border-transparent px-3 py-2 text-sm text-navy-700 hover:text-navy-900 [&.active]:border-navy-700 [&.active]:text-navy-900"
          activeProps={{ className: 'active' }}
        >
          {intl.formatMessage({ id: 'developers.tabs.apiKeys', defaultMessage: 'API keys' })}
        </Link>
        <Link
          to="/developers/webhooks"
          className="-mb-px border-b-2 border-transparent px-3 py-2 text-sm text-navy-700 hover:text-navy-900 [&.active]:border-navy-700 [&.active]:text-navy-900"
          activeProps={{ className: 'active' }}
        >
          {intl.formatMessage({ id: 'developers.tabs.webhooks', defaultMessage: 'Webhooks' })}
        </Link>
      </nav>

      <Outlet />
    </section>
  );
}
